import { Component } from '@angular/core';
import { SkeletonModule } from 'primeng/skeleton';
import { SkeletonHandoffDirective } from '../../../directives/skeleton-handoff.directive';

/**
 * Loading placeholder for the dashboard: mirrors the centered card grid of
 * `AuthenticatedDashboardComponent` while the user is loading.
 */
@Component({
  selector: 'app-dashboard-skeleton',
  standalone: true,
  hostDirectives: [SkeletonHandoffDirective],
  imports: [SkeletonModule],
  templateUrl: './dashboard-skeleton.component.html',
  styleUrl: './dashboard-skeleton.component.scss',
})
export class DashboardSkeletonComponent {
  /** Title and description line widths (percent) per card. */
  readonly cards = [
    { title: 45, lines: [90, 65] },
    { title: 50, lines: [80] },
    { title: 60, lines: [75] },
    { title: 35, lines: [55] },
  ];
}
